import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledHeader = styled.header`
  position: fixed;
  top: 24px;
  left: 28px;
  right: 28px;

  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.01em;
  font-weight: 400;
  color: #fff;

  @media (max-width: 600px) {
    top: 20px;
    left: 20px;
    right: 20px;
    font-size: 12px;
  }
`;

export const StyledLink = styled(Link)`
  color: #000 !important;
  text-decoration: none !important;
  font-weight: 400;
  cursor: pointer;
`;